<template>
  <v-dialog v-model="dialog" persistent max-width="550">
    <v-card>
      <v-card-title class="headline"> No Access! </v-card-title>
      <v-card-text>
        <p class="ma-0">Are you sure you are using the correct email?</p>
        <h5 class="mt-5">
          You have <b>No Access</b> to Webinarinc Learning Management System.
        </h5>
        <h5>Please email sales@webinarinc.com to upgrade your subscription.</h5>
      </v-card-text>
      <v-card-actions>
        <v-btn dark small @click="logout" :loading="loading"> logout </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="emailSales">
          Email Sales
        </v-btn>
        <v-btn color="#f9b418" text @click="goToCentral">
          Go back to Webinarinc Central
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'NoAccessLmsDialog',
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    dialog: {
      get() {
        return this.$store.state.app.noAccessLmsDialog;
      },
      set() {
        return this.$store.dispatch('app/toggleNoAccessLmsDialog');
      },
    },
  },
  methods: {
    emailSales() {
      window.location.href = 'mailto:sales@webinarinc.com';
    },
    goToCentral() {
      window.open('/central/profile');
    },
    logout() {
      this.loading = true;
      this.$http.post('/user/logout').then(({ data }) => {
        window.location.href = data;
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped></style>
